import React from 'react';
import { titleize } from 'underscore.string';
import { Glyphicon } from 'react-bootstrap';
import formatMoney from 'utils/formatters/Money';
const defaultFormatter = (cell) => React.createElement("span", null, titleize(cell));
const booleanFormatter = (cell, row) => (React.createElement("span", null, row.processed ? 'Yes' : 'No'));
const editFormatter = (cell, row) => {
    const editClass = { marginLeft: '6px' };
    if (!row.editClick) {
        return null;
    }
    return (React.createElement("button", { type: "button", onClick: row.editClick, className: "text-grey-darker", style: editClass },
        React.createElement(Glyphicon, { glyph: "edit" })));
};
const equipmentFormatter = (cell, row) => {
    return React.createElement("a", { onClick: row.viewClick }, cell);
};
const reverseFormatter = (cell, row) => {
    const removeClass = {
        pointerEvents: 'all',
        cursor: 'pointer',
        color: '#8795a1',
        fontWeight: 700,
        textAlign: 'center',
        marginLeft: '18px',
    };
    if (!row.reverseClick) {
        return null;
    }
    return (React.createElement("span", { onClick: row.reverseClick, style: removeClass }, "X"));
};
const shipmentFormatter = (cell, row) => {
    return (React.createElement("a", { href: `/shipments/${row.job_id}`, target: "_blank", rel: "noreferrer" }, cell));
};
const priceFormatter = (cell, row) => {
    const grayClass = {
        color: '#8795a1',
    };
    return React.createElement("span", { style: grayClass }, formatMoney(cell, row === null || row === void 0 ? void 0 : row.currency));
};
const boldPriceFormatter = (cell, row) => {
    const boldClass = {
        fontWeight: 700,
    };
    return React.createElement("span", { style: boldClass }, formatMoney(cell, row === null || row === void 0 ? void 0 : row.currency));
};
function determinePriceFormatter(cell, row, type) {
    if (row.ledger) {
        switch (row.ledger) {
            case 'payables':
                return type === 'shipper'
                    ? boldPriceFormatter(cell, row)
                    : priceFormatter(cell, row);
            case 'receivables':
                return type === 'carrier'
                    ? boldPriceFormatter(cell, row)
                    : priceFormatter(cell, row);
            default:
                break;
        }
    }
    return priceFormatter(cell, row);
}
const columns = [
    {
        dataField: 'shipment_id',
        text: 'Shipment',
        localizationSlug: 'SHIPMENT',
        count: 1,
        sort: true,
        formatter: shipmentFormatter,
    },
    {
        dataField: 'equipment.equipment_id',
        text: 'Equipment',
        localizationSlug: 'EQUIPMENT',
        sort: true,
        formatter: equipmentFormatter,
    },
    {
        dataField: 'message',
        text: 'Name (Description)',
        localizationSlug: 'NAME_DESCRIPTION',
        sort: true,
        formatter: defaultFormatter,
    },
    {
        dataField: 'processed',
        text: 'Processed',
        localizationSlug: 'PROCESSED',
        sort: false,
        formatter: booleanFormatter,
    },
    {
        dataField: 'shipper_rate',
        text: 'Shipper Rate',
        localizationSlug: 'SHIPPER_RATE',
        sort: false,
        align: 'right',
        formatter: (cell, row) => determinePriceFormatter(cell, row, 'shipper'),
    },
    {
        dataField: 'carrier_cost',
        text: 'Carrier Cost',
        localizationSlug: 'CARRIER_COST',
        sort: false,
        align: 'right',
        formatter: (cell, row) => determinePriceFormatter(cell, row, 'carrier'),
    },
    {
        dataField: 'reverse',
        text: 'Reverse',
        localizationSlug: 'REVERSE',
        sort: false,
        formatter: reverseFormatter,
    },
    {
        dataField: 'edit',
        text: 'Edit',
        localizationSlug: 'EDIT',
        sort: false,
        formatter: editFormatter,
    },
];
export default {
    columns,
};
